import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  Target,
  AlertTriangle,
  Zap,
  GitBranch,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// FieldCard
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const FieldCard = ({ icon: Icon, label, value, colorClass, bgClass }) => {
  if (!value) return null;
  return (
    <div className={`rounded-lg border p-4 ${bgClass}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{label}</span>
      </div>
      <p className="text-sm text-gray-700 leading-relaxed">{value}</p>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// AlternativesTable
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const AlternativesTable = ({ alternatives }) => {
  const [expanded, setExpanded] = useState(false);

  const families = alternatives.alternative_selected_structure_family || [];
  if (!families.length) return null;

  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
      >
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Structure Families Alternative ({families.length})
        </span>
        {expanded ? <ChevronUp className="w-4 h-4 text-gray-400" /> : <ChevronDown className="w-4 h-4 text-gray-400" />}
      </button>
      {expanded && (
        <div className="divide-y divide-gray-100">
          {families.map((name, i) => (
            <div key={i} className="p-4 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-gray-100 text-xs text-gray-500">{i + 1}</span>
                <span className="font-medium text-sm text-gray-800">{name}</span>
              </div>
              {alternatives.alternative_selection_rationale?.[i] && (
                <p className="text-xs text-gray-500 ml-8">{alternatives.alternative_selection_rationale[i]}</p>
              )}
              {alternatives.alternative_structural_risk?.[i] && (
                <div className="ml-8 flex items-start gap-1">
                  <AlertTriangle className="w-3 h-3 text-orange-500 flex-shrink-0 mt-0.5" />
                  <p className="text-xs text-orange-600">{alternatives.alternative_structural_risk[i]}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare la Structure Selection</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract06View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract06View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <Target className="w-6 h-6 text-yellow-600" />
            <h2 className="text-xl font-bold text-gray-800">Structure Selection</h2>
            <span className="px-2 py-0.5 text-xs bg-yellow-100 text-yellow-700 rounded-full font-medium">C06</span>
          </div>
          <p className="text-sm text-gray-500">La Structure Family selezionata per questa creativitÃ </p>
        </div>

        {/* Selected Family â€” Hero Card */}
        {output.selected_structure_family && (
          <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-5">
            <div className="flex items-center gap-2 mb-3">
              <CheckCircle2 className="w-5 h-5 text-yellow-600" />
              <span className="text-xs font-semibold text-yellow-700 uppercase tracking-wide">Selected Structure Family</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1">{output.selected_structure_family}</h3>
          </div>
        )}

        {/* Details */}
        <div className="space-y-3">
          <FieldCard
            icon={GitBranch}
            label="Selection Rationale"
            value={output.selection_rationale}
            colorClass="text-blue-700"
            bgClass="bg-blue-50 border-blue-200"
          />
          <div className="grid grid-cols-2 gap-3">
            <FieldCard
              icon={AlertTriangle}
              label="Structural Risk"
              value={output.structural_risk}
              colorClass="text-orange-700"
              bgClass="bg-orange-50 border-orange-200"
            />
            <FieldCard
              icon={Zap}
              label="Expected Prediction Error"
              value={output.expected_prediction_error}
              colorClass="text-purple-700"
              bgClass="bg-purple-50 border-purple-200"
            />
          </div>
        </div>

        {/* Alternatives */}
        <AlternativesTable alternatives={output} />

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract06View;
